import * as React from 'react'

import {
    Stack,
    Box,
    Button
} from '@mui/material'
import { useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom'

import {HashLink as Link } from "react-router-hash-link";

import { HeaderComponent, HeaderContent, IconsDiv, Logo, LogoDiv, MobileDiv, NavItem,  NavMenu, SearchDiv } from './styles';
import SideBar from '../../sidebar';


interface TopHeaderProps {
    reference?: any;
    title?: any;
}

const Navigation: React.FC<TopHeaderProps> = ({ reference, title }) => {

    const matches = useMediaQuery('(max-width:1100px)');

    const dataHeader = [
        {name:"SETRABH", label: "Setra", link: '/'},
        {name:"QUEM SOMOS", value: "us", link: '#us'},
        {name:"NOSSA HISTORIA", value: "ourhistory", link: '#ourhistory'},
        {name:"NOSSA MISSÃO", value: "ourmission", link: '#ourmission'},
        {name:"OPERAÇÃO E FROTA", value: "fleet", link: '#fleet'},
        {name:"NOTÍCIAS", value: "news", link: '#news'},
        {name:"CONTATO", value: "contact", link: '#contact'},
    ]

    React.useEffect(() => {
    },[title, reference])

    return (
        <HeaderComponent>
            {matches ? (
                 <MobileDiv>
                    <SideBar nome={dataHeader}/>
                    <h1>Menu</h1>
                </MobileDiv>
            ) : (
                <HeaderContent>
                    <NavMenu>
                        {dataHeader.map((item, index) => (
                            <React.Fragment key={item.value}>
                                <Link to={item?.link}>
                                    <NavItem
                                        key={item.value}
                                        active={item.value === 'home'}
                                        
                                    >
                                        {item.name}
                                    </NavItem>
                                </Link>
                                {index < dataHeader.length - 1 && (
                                    <span style={{ margin: '0 0.5px', color: 'var(--light-setra-blue)' }}>|</span>
                                )}
                            </React.Fragment>
                        ))}
                            
                    </NavMenu>
                </HeaderContent>
            )}
        </HeaderComponent>
    );
}

export { Navigation }